import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Company } from '../../../models/company';
import { Location } from '../../../models/location';
import { Equipment } from '../../../models/equipment';
import { Page } from '../../../models/paging/page';
import { Category } from '../../../models/category';
import { CompanyService } from '../../../services/company.service';
import { AuthService } from '../../../services/auth.service';
import { CategoryService } from '../../../services/category.service';
import { LocationService } from '../../../services/location.service';
import { EquipmentService } from '../../../services/equipment.service';
import { InspectionService } from '../../../services/inspection.service';
import { saveAs as importedSaveAs } from 'file-saver';
import { FilterService } from '../../../services/filter.service';
import { SnotifyService } from 'ng-snotify';
import { ReportableService } from '../../../services/reportable.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ViewEncapsulation } from '@angular/core';
import { ConfirmationService } from "primeng/api";
import { ModalService } from '../../../services/modal.service';
import * as moment from 'moment';


@Component({
  selector: 'app-asset-management',
  templateUrl: './asset-management.component.html',
  styleUrls: ['./asset-management.component.scss'],
  encapsulation: ViewEncapsulation.None
})


export class AssetManagementComponent implements OnInit {
  @ViewChild('equipmentTable') table!: DatatableComponent;

  filter: any = {
    company_Id: '',
    location_Id: undefined,
    category_Id: undefined,
    serial_Num: '',
    asset_Num: '',
    description: '',
    doc: '',
    inspection_Status: -1,
    showArchived: -1,
    date_Enabled: false,
    date_Range: 12,
    start_Date: moment().add(-12, 'months').toDate(),
    end_Date: moment().toDate(),
  };


  inspection_Statuss = [
      {
        text:'All',
        value: -1
      },
      {
        text:'Compliant',
        value: 0
      },
      {
        text:'Non-Compliant',
        value: 1
      },
      {
        text:'Not Presented',
        value: 2
      },
  ];
  archive_Items = [
    {
      text: 'All',
      value: -1
    },
    {
      text: 'Active',
      value: 0
    },
    {
      text: 'Archived',
      value: 1
    },

  ];

  loading: boolean = false;
  allRowsSelected: boolean = false;
  default_filters = JSON.parse(JSON.stringify(this.filter));
  requestNotes: String;
  pageno: number;
  locationList: Location[];
  company_Id;
  company: Company;
  companies: Company[];
  locations: Location[];
  triggerSubLocationUpdate: boolean = false;
  categories: Category[];
  page = new Page();
  uploadPage = new Page();
  uploadRows = Array<any>();
  rows = Array<Equipment>();
  selectedRows = Array<Equipment>();
  readOnly = false;
  equipAccess = false;
  user;
  showLocations: boolean = false;

  constructor(public companyService: CompanyService, public locationService: LocationService, public categoryService: CategoryService,
    public equipmentService: EquipmentService, public router: Router, private authService: AuthService, private filterService: FilterService,
    private snotifyService: SnotifyService, private reportableService: ReportableService, public confirmationService: ConfirmationService,
    public inspectionService: InspectionService, private modalService: ModalService) {
    this.user = this.authService.currentUser.value;

    if (this.authService.currentUser.value.userProfileId != 1&& this.authService.currentUser.value.userProfileId != 4) {
      this.readOnly = true;
    }
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.uploadPage.pageNumber = 0;
    this.uploadPage.size = 10;

    // Check if any filters are present
    var filters = this.filterService.getFilters(this.authService.currentUser.value.id, this.router.url);
    if (filters != null) {
      this.filter = filters;
      if (this.readOnly) {
        this.filter.showArchived = 0;
        this.onArchiveChanged(0);
      }
    }


  }


  ngOnInit(): void {

    this.filter.company_Id = this.router.parseUrl(this.router.url).queryParams["id"];
    this.company_Id = this.router.parseUrl(this.router.url).queryParams["id"];
    if (this.filter.company_Id == null) {
      this.snotifyService.error("Error loading company");
      this.loading = false;
      this.router.navigate(['']);
    }

    if (this.filter.company_Id != null) {
      this.companyService.get(this.filter.company_Id).then((c) => {
        this.company = c;
      }, (err) => {
        this.snotifyService.error("Error loading company details");
        this.loading = false;
        this.router.navigate(['']);

      });

      this.locationService.getAll(this.filter.company_Id).then((locations) => {
        //console.log("returned locations");
        var l = locations.filter(c => {
          return c.companyId == this.filter.company_Id;
        });

        if (l.length > 0)
          this.showLocations = true;
      });

    }
    this.loadTable();
  }


  onLocationChange(value) {
    if (value == undefined)
      this.filter.locationId = undefined;
    else
      this.filter.locationId = value.id;

  }
  onStatusChanged(value) {
    this.filter.inspection_Status = value.value;
  }
  onArchiveChanged(value) {
    this.filter.showArchived = value.value;
  }

  onCategoryChange(value) {
    if (value == undefined)
      this.filter.category_Id = undefined;
    else
      this.filter.category_Id = value.id;
  }
  edit(row) {
    ////console.log(row);
    this.router.navigate(['admin/assets/manage'], { queryParams: { id: row.id, company_Id: this.filter.company_Id } });
  }
  add() {
    this.router.navigate(['/admin/assets/manage'], { queryParams: { company_Id: this.filter.company_Id } });
  }
  back() {

    if (this.authService.currentUser.value.userProfileId == 3) {
      this.router.navigate(['']);
    } else {
      this.router.navigate(['admin/companies/overview'], { queryParams: { id: this.filter.company_Id } });

    }


  }
  resetFilters() {
    this.filter = this.filterService.parseFilters(JSON.stringify(this.default_filters));
    this.filter.category_Id = null;
    this.filter.location_Id = null;
    this.filter.company_Id = this.company_Id;
    if (this.readOnly) {
      this.filter.showArchived = 0;
      this.onArchiveChanged(0);
    }
    this.loadTable();
  }

  rebind() {
    this.page.pageNumber = 0;
    this.loadTable();
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable();
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    if (event.column.prop == this.page.sortBy && this.page.sortOrder == "asc") {
      this.page.sortOrder = "desc";
    } else {
      this.page.sortOrder = "asc";

    }

    // this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;

    this.loadTable();
  }

  archiveInspection(id) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want archive this inspection?',
      accept: () => {
        this.inspectionService.archive(id, this.authService.currentUser.value.id).then(() => {
          this.loadTable();
        });
      }
    });
  }

  refreshRows() {
    for (var i = 0; i < this.rows.length; i++) {
      var row = this.rows[i];
      if (this.selectedRows.some(x => x.id === row.id))
        row.selected = true;
      else
        row.selected = false;
    }

  }

  addAlltoBasket() {
    this.loading = true;
    this.allRowsSelected = !this.allRowsSelected;
    if (!this.allRowsSelected) {
      this.selectedRows = [];
      this.refreshRows();
      this.loading = false;

    } else {
      console.log(this.filter);
      this.equipmentService.getAllResults(this.page, this.filter.company_Id, this.filter.locationId, this.filter.category_Id, this.filter.serial_Num,
        this.filter.asset_Num, this.filter.contract_No, this.filter.description, this.filter.inspection_Status, this.filter.showArchived, this.filter.doc,
        !this.filter.date_Enabled ? null : this.filter.start_Date, !this.filter.date_Enabled ? null : this.filter.end_Date)
        .then((pagedData) => {
          for (var i = 0; i < pagedData.data.length; i++) {
            var row = pagedData.data[i];
            if (!row.inspection != null && row.inspection != undefined && row.inspection.inspection_Status != 'Not Located')
              this.addToBasket(row, 1);
          }
          this.refreshRows();
          this.loading = false;
        });

    }
  }


  loadTable() {
    this.loading = true;
    this.filterService.saveFilters(this.authService.currentUser.value.id, this.router.url, this.filter);
    this.equipmentService.getResults(this.page, this.filter.company_Id, this.filter.locationId, this.filter.category_Id, this.filter.serial_Num,
      this.filter.asset_Num, this.filter.contract_No, this.filter.description, this.filter.inspection_Status, this.filter.showArchived, this.filter.doc,
    !this.filter.date_Enabled ? null : this.filter.start_Date, !this.filter.date_Enabled ? null : this.filter.end_Date)
      .then((pagedData) => {
        if (pagedData != null) {
          this.page = pagedData.page;
          this.rows = pagedData.data;
          this.refreshRows();
        }

        this.loading = false;
      }, (err) => {
                this.loading = false;
          console.log(err);

      });
  }

  getRowClass = (row) => {
    return {
      'row-passed': (row.inspection != null && row.inspection != undefined && row.inspection.inspection_Status == "Safe to Operate"),
      'row-missing': (row.inspection != null && row.inspection != undefined && row.inspection.inspection_Status == "Not Located"),
      'row-failed': (row.inspection != null && row.inspection != undefined && (row.inspection.inspection_Status == "NOT Safe to Operate" || row.inspection.inspection_Status == "NOT Compliant")),
    };
  }

  generateExcel() {

    this.equipmentService.getExcel(this.page,
      this.filter.insurer_Id, this.filter.broker_Id,
      this.filter.company_Id, this.filter.location_Id,
      this.filter.category_Id, this.filter.serial_Num, this.filter.asset_Num, this.filter.showArchived).then((data) => {
        importedSaveAs(data, 'Equipment.xlsx');
      });
  }


  downloadReport(id: string, serial: string) {
    this.reportableService.getROTE(id).then((data) => {
      importedSaveAs(data, serial + ' Inspection Report.pdf');
    });
  }

  exportResults(type) {
    this.loading = true;
    if (this.selectedRows.length == 0) {

      if (type == 0) { //Excel
        this.equipmentService.getROTEExcel(this.filter).then((data) => {
          importedSaveAs(data, 'Inspection Reports.xlsx');
          this.loading = false;
        }, (err) => {
          this.snotifyService.error("A unexpected error occured when exporting this");
          this.loading = false;
        });
      } else if (type == 1) { //PDF
        this.equipmentService.getROTEPDF(this.filter).then((data) => {
          importedSaveAs(data, 'Inspection Reports.pdf');
          this.loading = false;
        }, (err) => {
          this.snotifyService.error("A unexpected error occured when exporting this");
          this.loading = false;
        });
      }
    } else {   ////ONly Selected Items
      if (type == 0) { //Excel
        this.reportableService.getBatchExcel(this.selectedRows).then((data) => {
          importedSaveAs(data, 'Inspection Reports.xlsx');
          this.loading = false;
        }, (err) => {
          this.snotifyService.error("A unexpected error occured when exporting this");
          this.loading = false;
        });
      } else if (type == 1) { //PDF
        this.reportableService.getBatch(this.selectedRows).then((data) => {
          importedSaveAs(data, 'Inspection Reports.pdf');
          this.loading = false;
        }, (err) => {
          this.snotifyService.error("A unexpected error occured when exporting this");
          this.loading = false;
        });
      }
    }
  }
  exportRegister(type) {
    this.loading = true;
    if (this.selectedRows.length == 0) {
      if (type == 0) { //Excel
        this.equipmentService.getRegisterExcel(this.filter).then((data) => {
          importedSaveAs(data, 'Register.xlsx');
          this.loading = false;
        }, (err) => {
          this.snotifyService.error("A unexpected error occured when exporting this");
          this.loading = false;
        });
      } else if (type == 1) { //PDF
        this.equipmentService.getRegisterPDF(this.filter).then((data) => {
          importedSaveAs(data, 'Register.pdf');
          this.loading = false;
        }, (err) => {
          this.snotifyService.error("A unexpected error occured when exporting this");
          this.loading = false;
        });
      }
    } else {

      if (type == 0) { //Excel
        this.reportableService.getRegisterExcel(this.selectedRows).then((data) => {
          importedSaveAs(data, 'Register.xlsx');
          this.loading = false;
        }, (err) => {
          this.snotifyService.error("A unexpected error occured when exporting this");
          this.loading = false;
        });
      } else if (type == 1) { //PDF
        this.reportableService.getRegister(this.selectedRows).then((data) => {
          importedSaveAs(data, 'Register.pdf');
          this.loading = false;
        }, (err) => {
          this.snotifyService.error("A unexpected error occured when exporting this");
          this.loading = false;
        });
      }
    }

  }
  // ###################################
  // BASKET
  // ###################################
  currentPageAdded: boolean = false;
  addToBasket(item, type) {
    if (this.selectedRows.some(x => x.id === item.id))
      return;

    item.selected = true;
    if(item.inspection != null && item.inspection != undefined)
      item.inspectionid = item.inspection.id;

    this.selectedRows.unshift(item);
  }

  openModal(id) {
    this.modalService.open(id);
  }
  cancelModal(id) {
    this.selectedRows = [];
    this.modalService.close(id);
    this.refreshRows();
  }

  request(row) {
    if (row != null)
      this.addToBasket(row, 1);

    if (this.selectedRows.length == 0) {
      this.snotifyService.error("Please select a item to request a inspection or replacement");
      return;
    }

    this.openModal('popup-request');

  }


  sendRequest(requestType) {
    var equipIds = [];
    for (var i = 0; i < this.selectedRows.length; i++) {
      var row = this.selectedRows[i];
      equipIds.unshift(row.id);

    }
    var requestDTO = {
      equipIds: equipIds,
      requestType: requestType,
      requestNotes: this.requestNotes,
      userId: this.user.id,
    }

    this.equipmentService.sendClientRequest(requestDTO).then((data) => {
      this.selectedRows = [];
      this.requestNotes = undefined;
      this.cancelModal('popup-request');
      this.snotifyService.success('Successfully sent request');
      this.refreshRows();
    });
  }
  removeFromBasket(item, type) {
    item.selected = false;
    var index = -1;
    for (var i = 0; i < this.selectedRows.length; i++) {
      var row = this.selectedRows[i];
      if (row.id == item.id)
        index = i;
    }
    if (index !== -1) {
      this.selectedRows.splice(index, 1);
    }

  }

  basketOnclickEvent(ev) {
    for (let i = 0; i < (this.rows.length); i++) {
      let row = this.rows[i];
      if ((ev.description == row.description) && (ev.serial_Num == row.serial_Num)) {
        this.rows[i].selected = false;
      }
    }
  }

  resetItem(item) {
    item.selected = false;
  }

  resetItems() {
    for (let item of this.rows) {
      this.resetItem(item);
    }

    // this.refreshbasketrow();
  }

  basketCompleted(data) {
    //console.log("basketCompleted");

    this.resetItems();

  }

  basketClearing(data) {
    //console.log("Clearing");
    this.resetItems();
  }

  onDetailToggle(event) {
  }
  toggleExpandRow(row) {
    this.table.rowDetail!.toggleExpandRow(row);
  }



  showUploadedFiles(row){
    this.selectedEquipment = row;
    this.loadUploadTable(this.uploadPage);
    this.openModal('popup-equipment-files');
  }

  selectedEquipment: Equipment = undefined;
  base64;
  fileName: string = undefined;

  uploadFile(files) {
    const file = (files.target as HTMLInputElement).files[0];
    this.fileName = file.name;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (reader.result != null && reader.result != undefined) {
        this.base64 = reader.result;
      }
    };

  }

  saveFile() {
    if (this.selectedEquipment != null && this.base64 != null && this.filter != null) {

      var dto = {
        id: this.selectedEquipment.id,
        Base64String: this.base64,
        File_Name: this.fileName,
        user: this.user.id
      };

      this.equipmentService.uploadFile(dto).then((result) => {
        this.base64 = null;
        this.fileName = null;
        this.loadUploadTable(this.uploadPage);
      }).catch((error) => {
        this.snotifyService.error(error);
      });

      (<HTMLInputElement>document.getElementById('filePicker')).value = '';
    }
  }

  // <!-- <a href="{{row.file_Id}}/{{row.file_Name}}" download ></a> -->
  downloadFile(row) {
    this.reportableService.getUploadedFile('EquipFiles', row.file_Id, row.file_Name).then((data) => {
      importedSaveAs(data, row.file_Name);
    })
  }

  removeFile(row) {
    let fileDetails = 'File Name: ' + row.file_Name + '<br/>';
    this.confirmationService.confirm({
      message: 'Are you sure that you want to remove this file?</br><br/>' + fileDetails,
      accept: () => {
        this.equipmentService.removeFile(row.id, row.file_Name).subscribe(result => {
          this.snotifyService.success("Removal successful");
          this.loadUploadTable(this.uploadPage);
        });
      }
    });
  }

  loadUploadTable(page: Page) {
    this.equipmentService.getEquipmentFiles(this.uploadPage, this.selectedEquipment.id).then((pagedData) => {
      this.uploadPage = pagedData.page;
      this.uploadRows = pagedData.data;
    });
  }

  selectedPopupLocation;
  sublocation_Id;
  

  transfer(row) {
    if (row != null)
      this.addToBasket(row, 1);

    if (this.selectedRows.length == 0) {
      this.snotifyService.error("Please select a item to transfer");
      return;
    }
    this.sublocation_Id = undefined;
    this.selectedPopupLocation = this.selectedRows[0].location_Id;
    this.openModal('popup-transfer');
  }

  onpopupLocationChange(value) {
    console.log(value);
    if (value == undefined)
      this.selectedPopupLocation = undefined;
    else
      this.selectedPopupLocation = value.id;

  }

onSublocationChange(value) {
  console.log("value");
  console.log(value);
    if (value == undefined)
      this.sublocation_Id = undefined;
    else
      this.sublocation_Id = value.id;
  }

  transferItem() {
    console.log(this.selectedPopupLocation);
    console.log(this.sublocation_Id);
    console.log(this.selectedRows);

    var equipIds = [];
    for (var i = 0; i < this.selectedRows.length; i++) {
      var row = this.selectedRows[i];
      equipIds.unshift(row.id);

    }
    var requestDTO = {
      equipIds: equipIds,
      location_Id: this.selectedPopupLocation,
      sublocation_Id: this.sublocation_Id,
      userId: this.user.id,
    }


    this.equipmentService.transferItems(requestDTO).then((data) => {
      this.selectedRows = [];
      this.requestNotes = undefined;
      this.cancelModal('popup-transfer');
      this.snotifyService.success('Successfully moved items');
      this.loadTable();
    });
    
  }

  dateChanged(){
    console.log("date changed");
    if(this.filter.date_Range == -2){
      this.filter.end_Date = moment(this.filter.start_Date).add(1,'day').toDate();
      console.log(this.filter.start_Date);
      console.log(this.filter.end_Date);
    }
  }
    dateChange(ev) {
    if (ev == -1) {
      return;
    }

    let date = moment();
    if (ev == 0) {
      date = date.subtract(1, 'weeks');
    } else {
      date = date.subtract(ev, 'months');
    }

    let jsDate = date.toDate();
    //var startDate: NgbDateStruct = { year: jsDate.getFullYear(), month: jsDate.getMonth() + 1, day: jsDate.getDate() };
    this.filter.start_Date = jsDate;
    if(ev == -2)
      this.filter.end_Date = date.add(1,'day').toDate();
  }
}